import axios from "axios"
import {useEventsBus} from '@haskoning/vue-component-library'

const { emit } = useEventsBus()

function getResponse (response) {
  let notShownMethods = ["get", "options"]
  if (!notShownMethods.includes(response.config.method)) {
    emit("success", response)
  }
  // Any status code within the range of 2xx cause this function to trigger
  emit("loading", false)
  return response
}

function getRequest (request) {
  emit("loading", true)
  return request
}

function headers () {
  const accessToken = localStorage.getItem("access")
  if (accessToken) {
    return {
      Authorization: `Bearer ${accessToken}`
    }
  } else {
    return {}
  }
}

async function manageErrorConnection (err) {
  if (err.response.status === 403 && err.response.data.code === "token_not_valid") {
    await getNewAccessToken()
    err.config.headers.Authorization = api.defaults.headers.Authorization
    return await axios.request(err.config)
  }
  emit("error", err)
  emit("loading", false)
  // bus.$emit('error', err);
  // Any status codes outside the range of 2xx cause this function to trigger
  // Do something with response error
  return Promise.reject(err)
}

async function getNewAccessToken () {
  let url = api.defaults.baseURL + "api/token/refresh/"
  const refreshToken = localStorage.getItem("refresh")
  if (refreshToken && refreshToken !== "null") {
    let response = await axios.post(url, { refresh: refreshToken })
    const accessToken = response.data.access
    api.defaults.headers.Authorization = `Bearer ${accessToken}`
    localStorage.setItem("access", accessToken)
  } else {
    return {}
  }
}

const api = axios.create({
  baseURL: import.meta.env.VITE_APP_API_BASE_URL,
  headers: headers()
})

api.interceptors.response.use(
  (response) => getResponse(response),
  manageErrorConnection
)
api.interceptors.request.use(
  (request) => getRequest(request),
  manageErrorConnection
)

export default api
